import { useEffect, useState } from 'react';
import Image from 'next/image';
import styles from '../styles/ChatbotWidget.module.css';
import * as cookieHelper from '../lib/cookieHelper';
import { isUserLoggedIn } from '../lib/chatbotAuth';
import * as LIB from '../lib/common';

const ChatbotWidget = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    // update login state
    const updateLoginState = async (refreshSession = false) => {
      if (refreshSession && process.env.runningEnv !== 'local') {
        await cookieHelper.refreshSessionData();
      }

      setLoggedIn(isUserLoggedIn());
    };

    updateLoginState(true);

    // handle sign in event
    const handleSignIn = async () => {
      await updateLoginState(true);
    };

    const handleSignOut = () => {
      setLoggedIn(false);
    };

    document.addEventListener('signin', handleSignIn);
    document.addEventListener('signoff', handleSignOut);

    return () => {
      document.removeEventListener('signin', handleSignIn);
      document.removeEventListener('signoff', handleSignOut);
    };
  }, []);

  const openChatbotPage = () => {
    // open chatbot page in a new tab
    window.open(LIB.getBasepath('/chatbot'), '_blank');
  };

  // if not logged in, don't show the chatbot widget  
  if (!loggedIn) {
    return null;
  }

  // if logged in, show the chatbot widget
  return (
    <div className={styles.fab}>
      <button
        type="button"
        className={styles.fabButton}
        onClick={openChatbotPage}
        title="日報小編 AI"
      >
        <Image
          src={LIB.getBasepath('/images/home/ai_icon.png')}
          height={90}
          width={90}
          alt="ai feature icon"
        />
      </button>
    </div>
  );
};

export default ChatbotWidget;
